import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Typography
} from '@material-ui/core';

//More modified copy-paste from Materials API/Example
//This time it's simpler though, so I understand what's happening more accurately
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  formControl: {
    margin: theme.spacing(0),
  },
  group: {
    margin: theme.spacing(0.5, 0),
  },
}));

export default function FilterCollection(props) {
  const classes = useStyles();
  const [typeValue, setTypeValue] = React.useState('program');
  const [unitValue, setUnitValue] = React.useState('expenditures');

  function handleTypeChange(event) {
    const value = event.target.value;
    setTypeValue(value);
    props.onTypeChange(value);
  }

  function handleUnitChange(event) {
    const value = event.target.value;
    setUnitValue(value);
    props.onUnitChange(value);
  }

  return (
    <div className={classes.root}>
      <FormControl component="fieldset" className={classes.formControl}>
        <RadioGroup
          aria-label="type"
          name="type"
          className={classes.group}
          value={typeValue}
          onChange={handleTypeChange}
        >
          <FormControlLabel 
            value="program" 
            control={<Radio />} 
            label="Program" 
          />
          <FormControlLabel 
            value="gvtMinistry" 
            control={<Radio />} 
            label="Government Ministry" 
          />
          <FormControlLabel 
            value="pType" 
            control={<Radio />} 
            label="Program Type" 
          />
        </RadioGroup>
      </FormControl>
      <Typography variant="h6" align="center">AND</Typography>
      <FormControl component="fieldset" className={classes.formControl}>
        <RadioGroup
          aria-label="unit"
          name="unit"
          className={classes.group}
          value={unitValue}
          onChange={handleUnitChange}
        >
          <FormControlLabel
            value="expenditures"
            control={<Radio color="primary" />}
            label="Expenditures"
          />
          <FormControlLabel
            value="caseloads"
            control={<Radio color="primary" />}
            label="Caseloads"
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
}